// extracted by mini-css-extract-plugin
module.exports = {"authCardWrap":"AuthCard_authCardWrap__sYb1q","authCardContent":"AuthCard_authCardContent__uLoA5","authTitleWrap":"AuthCard_authTitleWrap__um6L4"};